import {
	GroupInterfaceNameDocument,
	InterfaceFieldsFragment,
	useUpdateGroupHeatPumpNameMutation,
} from "generated/graphql"
import { useState, useEffect } from "react"
import EditableField from "./EditableField"
import { useMessage } from "providers/MessageProvider"
import appendErrorMessage from "tools/appendErrorMessage"
import { Typography, styled } from "@mui/material"
import { useTranslation } from "react-i18next"

const StyledTypography = styled(Typography)`
	display: inline-block;
	color: inherit;
	font-size: inherit;
	font-weight: inherit;
`

type Props = {
	interface: Pick<InterfaceFieldsFragment, "id" | "name">
	hideEdit?: boolean
}
export default function EditableGroupInterfaceName({ interface: iface, hideEdit }: Props) {
	const { t } = useTranslation(["heatPumpManagement"])
	const [name, setName] = useState(iface.name ?? iface.id)
	const message = useMessage()
	const [updateHeatPumpName] = useUpdateGroupHeatPumpNameMutation({
		refetchQueries: [{ query: GroupInterfaceNameDocument, variables: { heatPumpId: iface.id } }],
	})

	useEffect(() => {
		setName(iface.name ?? iface.id)
	}, [iface.name])

	const saveName = async () => {
		if (iface.name === name) {
			message.info(t("Errors.HPHasThisName"))
			return
		}
		try {
			await updateHeatPumpName({ variables: { name: name !== "" ? name : null, heatPumpId: iface.id } })
			message.success(t("NameChanged"))
		} catch (e) {
			message.error(appendErrorMessage(t("Errors.UnkownErrorChangingName"), e))
		}
	}
	if (hideEdit) return <StyledTypography>{iface.name}</StyledTypography>

	return <EditableField value={name} onChange={(e) => setName(e.target.value)} onBlur={saveName} />
}
